<template>
  <section class="multiple-accounts">
    <h3>{{ $t('chooseAnAccount') }}</h3>
    <p>{{ $t('yourCredentialsMatchMultipleAccounts') }}:</p>
    <div class="list-group mb-4">
      <button
        v-for="account in accounts"
        :key="account.id"
        :data-account-id="account.id"
        class="list-group-item list-group-item-action multiple-accounts__btn-account-select"
        @click="select(account)"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div class="mr-4">
            <span class="d-block"
              ><strong>{{ $t('accountNumber') }}:</strong> {{ account.accountNumber }}</span
            >
            <span class="d-block"
              ><strong>{{ $t('name') }}:</strong> {{ account.displayName }}</span
            >
          </div>
          <font-awesome-icon icon="chevron-right"></font-awesome-icon>
        </div>
      </button>
    </div>
    <button
      type="button"
      class="btn btn-outline-dark btn-block multiple-accounts__btn-cancel"
      @click="cancel"
    >
      {{ $t('cancel') }}
    </button>
  </section>
</template>

<script>
export default {
  name: 'WCMultipleAccounts',
  props: {
    accounts: {
      type: Array,
    },
  },
  methods: {
    select(account) {
      this.$emit('select', account);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped lang="scss"></style>
